import FacePerson from '@/services/api/face-person';

export default {
  actions: {
    loadFacePersons (state, { abonentId }) {
      return FacePerson.load({ abonentId });
    },
    deletePersonPhoto (state, { id }) {
      return FacePerson.deletePhoto({ id });
    },
    uploadPhoto (state, { req }) {
      return FacePerson.uploadPhoto({ req });
    },
    createFacePerson (state, { abonentId, name }) {
      return FacePerson.createFacePerson({ abonentId, name });
    },
  },
};
